import { baseUrl } from '../../config/appsettings';

const InvoiceApiService = {
  // Admin: Get all invoices
  getAllInvoices: async () => {
    try {
      const response = await fetch(`${baseUrl}Invoice/Get`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) throw new Error((await response.json()).message || 'Error occurred');
      return await response.json();
    } catch (error) {
      console.error('getAllInvoices error:', error);
      throw new Error('Network error');
    }
  },

  // Publisher: Get invoices by user ID
  getInvoicesByUserId: async (userId) => {
    try {
      const response = await fetch(`${baseUrl}Invoice/Get/${userId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) throw new Error((await response.json()).message || 'Error occurred');
      return await response.json();
    } catch (error) {
      console.error('getInvoicesByUserId error:', error);
      throw new Error('Network error');
    }
  },

  // InvoiceApiService.js

updateInvoiceStatus: async (invoiceId, newStatus) => {
  try {
    const apiEndpoint = `${baseUrl}Invoice/UpdateStatus/${invoiceId}`;
    const response = await fetch(apiEndpoint, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ status: newStatus }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error occurred');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Update status error:', error);
    throw new Error('Network error');
  }
},


  // Delete invoice by ID
  deleteInvoice: async (invoiceId) => {
    try {
      const response = await fetch(`${baseUrl}Invoice/${invoiceId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) throw new Error((await response.json()).message || 'Error occurred');
      return await response.json();
    } catch (error) {
      console.error('deleteInvoice error:', error);
      throw new Error('Network error');
    }
  },

  // Update invoice (e.g. mark as paid, change status)
  updateInvoice: async (data) => {
    try {
      const response = await fetch(`${baseUrl}Invoice/Update`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error((await response.json()).message || 'Error occurred');
      return await response.json();
    } catch (error) {
      console.error('updateInvoice error:', error);
      throw new Error('Network error');
    }
  },

  // Create new invoice
  createInvoice: async (data) => {
    try {
      const response = await fetch(`${baseUrl}Invoice/Create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error((await response.json()).message || 'Error occurred');
      return await response.json();
    } catch (error) {
      console.error('createInvoice error:', error);
      throw new Error('Network error');
    }
  },

  // Get invoice by ID
  getInvoiceById: async (invoiceId) => {
    try {
      const response = await fetch(`${baseUrl}Invoice/GetById/${invoiceId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) throw new Error((await response.json()).message || 'Error occurred');
      return await response.json();
    } catch (error) {
      console.error('getInvoiceById error:', error);
      throw new Error('Network error');
    }
  },
};

export default InvoiceApiService;
